export const authDesktopNavigationList = [
  { id: "home", label: "Home", href: "" },
  { id: "challenges", label: "Challenges", href: "challenges" },
  // { id: 'paths', label: '🗺️ Paths', href: 'paths' },
  { id: "markets", label: "Live Markets", href: "markets" },
  { id: "progress", label: "Progress", href: "progress" },
  { id: "badges", label: "Badge Collection", href: "badges" },
  { id: "leaderboard", label: "Leaderboard", href: "leaderboard" },
];

export const notAuthDesktopNavigationList = [
  { id: "home", label: "Home", href: "" },
  { id: "challenges", label: "Challenges", href: "challenges" },
  // { id: 'paths', label: '🗺️ Paths', href: 'paths' },
  { id: "markets", label: "Live Markets", href: "markets" },
];

export const authNavigationTabs = [
  "home",
  "challenges",
  "markets",
  "progress",
  "badges",
  "leaderboard",
];

export const notAuthNavigationTabs = ["home", "challenges", "markets"];
